import { render, staticRenderFns } from "./ReminderTypeList.vue?vue&type=template&id=b498e454&"
import script from "./ReminderTypeList.vue?vue&type=script&lang=js&"
export * from "./ReminderTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports